import { useContext } from 'react';

import { AuthContext } from '@savvy/deprecated-shared/contexts/jwt-context.context';

export function useAuth() {
  return useContext(AuthContext);
}
